/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';

export const recordAppleSearchAdsV1ResponseDataSchema = z.object({
  recorded: z.boolean(),
  sourceKind: z.enum(['apple_search_ads', 'unknown']),
});

export type IRecordAppleSearchAdsV1ResponseData = z.infer<
  typeof recordAppleSearchAdsV1ResponseDataSchema
>;

export const recordAppleSearchAdsV1ResponseSchema = createApiResponseSchema(
  recordAppleSearchAdsV1ResponseDataSchema,
) as z.ZodSchema<IAPI<IRecordAppleSearchAdsV1ResponseData>>;

export type IRecordAppleSearchAdsV1Response = IAPI<IRecordAppleSearchAdsV1ResponseData>;
